<div class="confirm-dialog">
  <div mat-dialog-content class="confirm-dialog-message">
    {{ data.message }}
  </div>
  <!-- Regular GL Display -->
  <div class="alignC" *ngIf="!isDDA">
    <span class="pad25" style="background-color: #5ab4c3;">Total: {{ useTotal }}</span>
    <span class="pad25">Credit: {{ useGLCredit }}</span>
    <span>Debit: {{ useGLDebit }}</span>
  </div>

  <!-- DDA Transactions Present -->
  <div class="alignC" *ngIf="isDDA">
    <div class="container">
      <!-- GL -->
        <div class="row-item"><span class="background-light-blue">GL Total: {{ useGLTotal }}</span></div>
        <div class="row-item">GL Credit: {{ useGLCredit }}</div>
        <div>GL Debit: {{ useGLDebit }}</div>
      <!-- DDA -->
        <div class="row-item"><span class="background-light-blue">DDA Total: {{ useDDATotal }}</span></div>
        <div class="row-item">DDA Credit: {{ useDDACredit }}</div>
        <div>DDA Debit: {{ useDDADebit }}</div>
    </div>
    <!-- Total -->
    <div>
      <span class="background-blue">Total: {{ useTotal }}</span>
    </div>
  </div>

  <div class="alignR">
    <mat-checkbox [(ngModel)]="checkedOff">Send out of balance</mat-checkbox>
  </div>

  <div mat-dialog-actions class="pt-30" class="confirm-dialogBtn-Container">
    <button
      class="cancelBtn"
      mat-stroked-button
      (click)="closeDialog(false)"
    >
      Close
    </button>
    <button
      [disabled]="checkIfDisabled()"
      mat-raised-button
      class="mat-accent mr-16"
      (click)="closeDialog(true)"
    >
      Confirm
    </button>
  </div>
</div>
